import { Drawer } from 'antd';
import { ReactNode } from 'react';
import './style.scss';

interface IProps {
  readonly renderContent: () => ReactNode;
  readonly visible: boolean;
}

export const FullScreenDrawer = (props: IProps) => {
  return (
    <Drawer
      className="full-screen-drawer"
      placement="right"
      width="100%"
      closable={false}
      visible={props.visible}
      headerStyle={{
        display: 'none',
      }}
    >
      {props.renderContent()}
    </Drawer>
  );
};
